import { useI18n } from 'vue-i18n';
import { updateLocale } from '@/i18n';

const localeMap = {
    pt: 'pt_BR',
    es: 'es',
    en: 'en',
    fr: 'fr',
    it: 'it',
    zh: 'zh',
};

const normalizeLocale = (locale) => {
    if (!locale) {
        return null;
    }

    const normalized = locale.split(/[-_]/)[0].toLowerCase();

    return localeMap[normalized] ?? locale;
};

export function useTranslation() {
    const { t, locale, tm } = useI18n();

    const setLocale = (newLocale) => {
        const mapped = normalizeLocale(newLocale);

        if (mapped) {
            locale.value = mapped;
            updateLocale(newLocale);
        }
    };

    return {
        t,
        tm,
        setLocale,
        locale,
    };
}
